import type { AgentProfile } from '../types';

/** Do not persist passwordHash or other sensitive API fields in localStorage */
export function toAgentProfile(raw: Record<string, unknown>): AgentProfile {
  const parsedRate =
    raw.costRate != null
      ? Number(raw.costRate)
      : raw.cost_rate != null
        ? Number(raw.cost_rate)
        : undefined;
  const rawDelegate = raw.can_delegate_popups ?? raw.canDelegatePopups;
  const can_delegate_popups =
    rawDelegate === true || rawDelegate === false ? Boolean(rawDelegate) : undefined;

  const email =
    raw.email != null && String(raw.email).trim() !== '' ? String(raw.email) : '';
  const phone =
    raw.phone != null && String(raw.phone).trim() !== '' ? String(raw.phone) : null;

  const emailVerifiedRaw =
    (raw.emailVerified ?? raw.email_verified ?? raw.is_email_verified) as unknown;
  const phoneVerifiedRaw =
    (raw.phoneVerified ?? raw.phone_verified ?? raw.is_phone_verified) as unknown;
  const emailVerifiedAtRaw =
    (raw.emailVerifiedAt ?? raw.email_verified_at ?? raw.email_verifiedAt) as unknown;
  const phoneVerifiedAtRaw =
    (raw.phoneVerifiedAt ?? raw.phone_verified_at ?? raw.phone_verifiedAt) as unknown;

  return {
    id: String(raw.id ?? ''),
    email,
    phone,
    name: String(raw.name ?? ''),
    status: String(raw.status ?? ''),
    costRate: parsedRate,
    emailVerified: emailVerifiedRaw == null ? undefined : Boolean(emailVerifiedRaw),
    phoneVerified: phoneVerifiedRaw == null ? undefined : Boolean(phoneVerifiedRaw),
    emailVerifiedAt:
      emailVerifiedAtRaw == null ? undefined : String(emailVerifiedAtRaw),
    phoneVerifiedAt:
      phoneVerifiedAtRaw == null ? undefined : String(phoneVerifiedAtRaw),
    ...(can_delegate_popups !== undefined ? { can_delegate_popups } : {}),
  };
}
